var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChadflirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 603.03 425.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-8, .cls-9, .cls-11, .cls-12 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-11 {\n        stroke: #e9e9e9;\n      }\n\n      .cls-1, .cls-12 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #a09e9f;\n      }\n\n      .cls-2, .cls-8 {\n        fill: #a1a0a0;\n      }\n\n      .cls-3, .cls-13 {\n        fill: #b2b2b2;\n      }\n\n      .cls-3, .cls-10 {\n        stroke: #b3b3b3;\n      }\n\n      .cls-4 {\n        fill: #a19f9f;\n        stroke: #a19f9f;\n      }\n\n      .cls-5, .cls-6 {\n        stroke: #626464;\n      }\n\n      .cls-5, .cls-14 {\n        fill: #626363;\n      }\n\n      .cls-6 {\n        fill: #626464;\n      }\n\n      .cls-15 {\n        fill: #9b9a9a;\n      }\n\n      .cls-15, .cls-13, .cls-14 {\n        stroke-width: 0px;\n      }\n\n      .cls-7 {\n        fill: #d4d4d4;\n        stroke: #d4d4d4;\n      }\n\n      .cls-7, .cls-10 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-8 {\n        stroke: #a09f9f;\n      }\n\n      .cls-9 {\n        fill: #494849;\n      }\n\n      .cls-9, .cls-12 {\n        stroke: #484848;\n      }\n\n      .cls-10 {\n        fill: #b3b3b3;\n      }\n\n      .cls-11 {\n        fill: #e9e9e9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M258.17,82.72l-34.95,124.98-9.3,28.18s-43.14,9.23-57.98,24.06c-14.84,14.83-10.72,5.88-18.2,19.1s53.01,128.99,53.01,128.99l117.28,16.63,173.26-23.82-33.53-135.42-83.58-30.99-10.14-136.65-76.15-38.85-19.7,23.78h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M348,137.16s-7.6,7.79-11.15,9.47-2.57,12.33-2.57,12.33c0,0,1.58,21.02.79,23.58-.79,2.57-13.71,27.13-13.71,27.13l-8.85,5.66-26.51-2.29-23.16-15.1.72,17.39s16.81,24.49,23.61,25.7c6.8,1.2,19.74,3.24,28.68,2.13s10.67-2.53,10.67-2.53l-10.19,27.95s-2.82,8.79,0,13.19l9.3-5.06,22.37-1.03,21.42-6.68-3.86-91.27-9.38-53.78-26.88-36.91-46.92-4.33-17.73,8.79-20.62,42.1s6.92-1.44,12.25-5.33c5.33-3.89,19.77-28.93,28.38-32.7,4.74-2.08,9.94-2.56,16.55.59,1.16-.47,10.1-3.23,15.85-.68,7.05,3.13,17.51,23.26,17.51,23.26l13.43,18.4v.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M384.08,267.62l25.54-5.72s18.92.15,22.07,2.86,18.93,32.58,21.7,46.48c3.17,15.85-.93,44.15,3.9,56.95s18.32,20.36,18.32,20.36l16.47-4.9,6.64-8.37-15.77-50.06-11.53-32.61-5.78-11.85-10.88-14.24-13.79-10.48-24.04-10.24-32.85-11.37v33.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M307.15,318.98s-1.23,32.33,6.57,56.43c2.69,8.32-8.83,5.9-8.83,5.9l-2.97-9.83.33-42.37,4.9-10.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M267.76,215.34s9.05,29.42-4.66,39.58c-13.71,10.16-7,14.17,0,15.92,21.87,5.47,21.87,9.51,21.87,9.51l-30.14-5.82-16.56-3.57-1.29-47.57,30.78-8.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M440.15,316.54s-4.65,26.72,2.19,36.66c8.92,12.97,12.38-9,12.38-9l26.56,46.66-72.27-2.3-2.99-5.99,18.91-15.44,15.22-50.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M193.87,261.74s10.25-4.03,13.28-9.78,6.34-10.79,6.34-10.79l1.81,26.93-21.42-6.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M278.11,177.66s8.7,11.68,19.24,13.34,25.77-9.14,27.72-11.67-3.04-3.08-3.04-3.08c0,0-25.01-2.28-34.9-.98s-9.02,2.39-9.02,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.26,315.18l55.92,23.45s37.08,10.44,39.95,10.82,29.93-2.62,29.93-2.62l24.89,3.12,1.51-6.68,37.4-107.61-5.73-.26-12.65-.57-34.71,17.44-46.42,1.15s-3.79-17.79-3.81-21.05,2.68-42.38,5.07-47.93,7.85-21.56,7.85-21.56l3.33-1.36,7.39,5.09,15.92-9.6.88-4.96,7.37-6.03s11.29-6.08,13.37-10.29,5.46-3.67,5.46-3.67l6.31-12.74-29.97-29.63-14.64-.14-31.05,31.54-30.44,16.64-14.85,56.77s-29.69,50.27-30.55,53.96-6.81,16.41-7.09,38.97-3.4,26.25-3.4,26.25l2.75,1.48v.02h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M146.52,302.07s-15.7,11.97-26.69,12.36c-21.91.79-64.92-9.47-64.92-9.47,0,0-39.45.06-38.73-17.13.72-17.19-1.43-41.32,5.49-51.46s6.92-19.94,6.92-19.94c0,0-21.2,29.02-20.26,34.8.94,5.78-3.6,44.05-3.86,47.14s-2.97,15.31-2.97,15.31c0,0,12.96,8.23,19.21,10.65,6.25,2.42,47.95,17.1,47.95,17.1l31.46,8s25.3-3.2,29.93-2.62,35.76,3.81,35.76,3.81l18.5,44.88,11.63,13.26s-5.47-18.51,0-31.72,8.85-23.02,8.85-23.02c0,0-29.63-19.64-31.44-24.38s-11.3-15.63-14.93-19.4-11.92-8.19-11.92-8.19l.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.35,166.63s-6.16,34.53-6.78,47.16c-.17,3.5-.7,9.58-1.6,16.82-2.35,18.86,6.68,43.5-7.58,55.36-13.28,11.05-28.91,26.64-28.91,26.64,0,0,33.59-16.13,40.12-24.72s16.82-23.44,15.31-36.41-3.34-25.77-3.34-25.77l6.89-46.31,4.48-12.78h-18.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.42,274.73s12.67-15.09,15.63-23.72,16.87-33.16,16.87-33.16l-1.87,34.43.11,4.51s-.52-9.97-5.96-7.94-24.79,25.87-24.79,25.87h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.66,313.16s-13.72-8.74-5.78-20.98,20.94-29.16,29.1-28.48,29.82,14.24,29.82,14.24c0,0-6.99-7.91-2.91-15.2s21.8-22.71,21.8-22.71l-26.56,12.25-41.76,1.15-31.93,37.16-10.88,18.59,39.12,3.98h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.09,155.68s12.45,3.9,19.56-2.65,12.81-10.61,12.81-10.61c0,0,8.49,10.63,11.47,11.57s7.94-.51,10.91-3.7l-8.89-17.44.32-4.24s9.27,12.87,11.07,14.11c4.52,3.11,8.74-3.13,8.74-3.13l-11.96-20.79-.03-4.15s10.64,14.54,15.69,17.42c3.83,2.18,11.11-5.26,11.11-5.26,0,0-19.16-20.61-19.51-22.25s.79-2.48.79-2.48c0,0,17.56,17.44,19.83,19.1,4.43,3.23,10.49-1.85,10.49-1.85l-9.51,15.04-3.96-.21-10.25,11.07-11.28,8.43-.47,3.37-15.35,8.57-7.27-3.52-9.52,5.22s-20.44-4.91-21.69-8.03-3.12-3.59-3.12-3.59h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.36,234.41s12.48,9.66,13.82,13.43c3.11,8.78-5.24,14.89-5.24,14.89,0,0,17.16-7.36,17.39-10.46s2.59-10.9,1.26-13.73-27.23-4.13-27.23-4.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M428.27,62.52s-1.19-13.19-3.79-15.91-18.38-6.08-21.76-1.69-8.31,15.31-3.79,25.93c1.72,4.04,9.93,20.12,10.23,22.62s.42,4.32.42,4.32c0,0,14.76-8.2,19.39-10.38s25.62-9.85,23.47-17.38-7.94-11.02-11.54-10.96-12.63,3.45-12.63,3.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M259.7,123.31s2.19,5.35,3.26,6.26,13.49,5,15.84,5,9.79-3.23,10.62-5.96c0,0-8.57-5.77-12.28-5.82s-17.43.51-17.43.51h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.51,123.02s-.58,5.54.62,7.08,9.29,2.84,9.29,2.84l5.68-7.09-4.91-2.11-10.68-.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.28,55.66s-.15-5.65,5.46-7.73c4.12-1.52,7.7-.44,7.7-.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M201.53,131.82l13.03,25.88-2.57,17.24-12.7,4.13-7.88-2.58,7.88,6.62h11.13l-12.23,16.78-5.79,14.63,2.35,11.17s1.62-10.88,8.86-15.49c0,0,2.54,16.93,7.32,21.78s14.61,22.85,14.61,22.85c0,0,26.19-4.8,25.77-23.54s-6.2-50.33-6.2-50.33l5.86-14.86,10.07-1.84-11.2-4.45-3.91-25.17s4.05-9.04,3.78-12.61c-.46-6.09,5.61-6.18,5.61-6.18,0,0,9.7-5.59,12.42-14.03s8-25.1,8-25.1l20.43,2.36,37.37,7.12s.95,17.98,7.49,24.09,12.08,10.28,21.42,11.15,29.71-2.44,21.94-13.65-19.2-45.78-22.41-51.19-22.91-21.16-32.69-18.88-30.59,9.95-30.59,9.95c0,0-13.34-8.86-28.78-8.52-15.45.34-24.07,11.86-33.17,26.08-9.1,14.23,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M349.06,204.15s-17.22,22.63-12.27,38.61,10.57,7.71,10.57,7.71l2.95-6.53,18.92,20.69,14.45-16.49s11.78-18.24,13.13-26.7-1.61-21.29-1.61-21.29l-30.79-29.2-15.36,33.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M277.27,39.17s10.87,6.36,12.08,11.33.75,6.08.75,6.08c0,0-5.09-2.68-11.9-2.59s-9.55,1.16-9.55,1.16c0,0,6.73-.75,12.13,2.33s11.63,8.72,12.3,15.12.56,7.46.56,7.46c0,0-15.76-7.04-19.98-4.98-4.64,2.26-2.61,16.53-2.61,16.53,0,0,15.3-3.82,19.4-3.82s13.39,2.72,13.39,2.72c0,0,11.01-4.12,21.81-1.21,3.66.99,6.13.31,6.13.31,0,0,.71-15.31-3.42-14.99s-16.59,4.96-16.59,4.96l-5.55,3.11s3.83-7.13,4.13-11.63,3.49-12.82,11.59-15.67,11.9-2.12,11.9-2.12c0,0-9.11-7.06-19.74-2.92-3.08,1.2-4.58,2.25-4.58,2.25,0,0,2.15-5.79,8.48-8.93,10.76-5.33,14.88-5.68,14.88-5.68l-33.71,7.26-21.9-6.06v-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.41,59.07s4.77,14.26-.96,12.05-8.97-6.47-16.62-8.24c0,0,8.27,6.62,9.72,16.33s6.9,28.59,6.9,28.59c0,0,4.45,5.92,12.52,5.65s2.1,3.3,2.1,3.3c0,0-12.59,9.51-19.11,4.94s-2.91,8.83-2.91,8.83c0,0,6.58,12.86-2.44,24.16,0,0-.53,5.32-6.04,6.4s-7.9,2.05-7.9,2.05c0,0,10.27,4.12,13.33,3.96s3.12,17.22,3.12,17.22l-13.67,11.51-1.85,27.24-2.81,5.56s3.15-7.88,11.9-20.07,11.25-18.72,13.6-33.48c0,0,12.88,12.7,11.9,25.09s-6.55,20.94-6.55,20.94c0,0,13.1-3.84,17.75-16.24,1.56-4.16,1.41-12.06,1.41-12.06,0,0,4.76,3.37,8.03,9.39,3.06,5.64,3.24,8.09,3.24,8.09,0,0,6.97,6.3,8.09,9.07,2.01,4.95-.34,12.22-.34,12.22,0,0,7.16-14.8,4.72-21.74-3.15-8.95-19.67-28.18-19.67-28.18,0,0,3.83,4.22,10.17,2.22s11.45-8.29,11.45-8.29c0,0-10.95,5.47-17.67-.03-6.24-5.1-6.6-15.18-4.64-22.96s8.8-6.26,10.94-20.51c3.16-21.05-17.07-28.75-17.07-28.75,0,0,3.16-15.85-9.41-25.77-11.3-8.92-9.25-15.43-11.24-18.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.07,245.27s8.25,11.61,19.64,17.47c3.1-.9,12.54-11.11,12.14-16.46-.74-9.78,13.22-18.56,13.22-18.56,0,0-7.91,11.53-7.74,17.63s6.23,24.1-11.18,33.01-21.34,4.78-21.34,4.78c0,0,9.13-7.37,9.98-15.05s-9.1-9.71-12.78-17.37c-1.5-3.12-1.94-5.46-1.94-5.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.58,238.07s1.54,6.55,3.99,10.15,7.27,4.16,7.27,4.16l4.23,7.86s-11.98-4.07-13.04-7.81-2.45-14.37-2.45-14.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.89,228.57s12.19,6.22,14.74,10.79c4.56,8.16-.06,15.11-.06,15.11,0,0,18.91-3.16,21.97-19.93,1.34-7.36-4.4-26.25,1.06-37.45,2.74-5.64,4.99-11.25,4.99-11.25l11.82,12.11.43,22.2s9.56,29.07-.63,34.97-10.61,4.25-10.61,4.25c0,0,8.61-8.25-.04-16.03-6.03-5.42.45,1.58.45,1.58,0,0-5.48,10.64-11.53,15.85s-3.01,12.06-.82,15.78,6.49,6.68,6.49,6.68c0,0-18.05-.95-22.92-6.02s-10.98-13.18-9.55-28.17-2.96-11.21-5.79-20.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.54,187.4s15.34-9.54,19.5-12.54c4.83-3.48,6.41-16.9,6.41-16.9,0,0,6.55,8.04,14.23,8.89,2.18.24-1.48,24.09-1.31,26.49.34,4.75,2.44-11.43-12.58-7.49-11.15,2.92-18.22,18.65-18.22,18.65,0,0-.36-10.75,2.42-17.39,0,0-7.14,1.33-12.3,4.35-6.57,3.85-10.4,8.25-10.4,8.25l12.25-12.3h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "233.11 72.09 217.48 91.58 217.48 104.25 203.92 115.93 200.88 132.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M315.15,175.23s1.87,2.89,1.29,5.6-2.07,5.95-2.07,5.95l12.25-10.03-11.46-1.52h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.24,175.23s-1.87,2.89-1.29,5.6,2.07,5.95,2.07,5.95l-12.25-10.03,11.46-1.52h.01Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "200.88 132.86 209.53 109.88 217 102.55 227.85 76.28 239.72 81.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M351.96,155.88c.83-9.55,4.27-20.7,4.27-20.7,0,0,.35-.87-2.78-6.94l-.71-9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M301.22,215.23s10.58.63,13.52-1.12c11.12-6.63,39.36-30.12,39.36-30.12,0,0-1.39-8.03-2.04-16.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M340.23,195.25s-.63,7.44-.63,13.33v11.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M317.47,268.59c1.26-8.99,14.19-47.94,14.19-47.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M311.89,285.97s9.39-7.55,11.7-7.55,36.13-4.31,40.58-6.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M409.01,262.74c-8.39,3.27-21.87,5.36-21.87,5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M392.17,237.35s46.1,13.44,54.31,21.49,17.31,9.35,30.32,45.13,20.49,68.63,20.49,68.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M441.03,308.2s-9.76,49.44-17.89,59.84-20.82,15.61-20.82,15.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M306.48,317.75s-5.06,13.16-5.21,21.7-.05,33.15-.05,33.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M301.27,174.04s10.71-.52,17.43,1.03,12.96-.48,12.96-.48c0,0-7.27,7.33-13.48,11.86-6.21,4.53-11.17,5.95-16.97,6.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M309.96,181.91s8.1-.25,12.37-2.45,6.98-2.7,6.98-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 301.22,
    y1: 200.15,
    x2: 304.56,
    y2: 200.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M305.56,162.98s1.48-.09,2.06.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 301.22,
    y1: 200.15,
    x2: 297.88,
    y2: 200.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M250.65,155.89c-.83-9.56-4.28-20.74-4.28-20.74,0,0-.35-.87,2.78-6.94l.71-9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M301.22,215.23s-10.58.63-13.52-1.12c-11.12-6.63-39.36-30.12-39.36-30.12,0,0,1.42-8.17,2.06-16.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M262.2,195.25s.63,7.44.63,13.33v11.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M270.78,220.65s12.93,38.95,14.19,47.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M290.55,285.97s-9.39-7.55-11.7-7.55-36.13-4.31-40.58-6.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M215.29,268.1s-13.48-2.1-21.87-5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M301.17,174.04s-10.71-.52-17.43,1.03-12.96-.48-12.96-.48c0,0,7.27,7.33,13.48,11.86s11.17,5.95,16.97,6.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M292.48,181.91s-8.1-.25-12.37-2.45-6.98-2.7-6.98-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 301.22,
    y1: 200.15,
    x2: 297.88,
    y2: 200.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296.88,162.98s-1.48-.09-2.06.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M301.22,75.52c-1.13,0-3.8.66-4.37,2.07s-5.42,11.79-5.42,11.79c0,0-1.07,4.12-5.43,4.77s-19.77.65-26.05-1.95-6.61-9.87-6.61-9.87l-1.93-15.18,10.36-2.38s24.91,1.63,29.66,3.58,5.42,3.13,5.42,3.13c0,0,1.28-1.18,4.37-1.18s4.37,1.18,4.37,1.18c0,0,.68-1.18,5.42-3.13s29.66-3.58,29.66-3.58l10.34,2.52-1.92,15.05s-.33,7.26-6.61,9.87-21.69,2.6-26.05,1.95-5.43-4.77-5.43-4.77c0,0-4.85-10.38-5.42-11.79s-3.25-2.07-4.37-2.07h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 301.22,
    y1: 200.15,
    x2: 304.56,
    y2: 200.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M343.9,128.96s-9.68-1.18-14.59-.83c-4.91.35-10.57,4.02-10.57,4.02,0,0,1.21-4.32,4.08-5.4s7.7-3.23,7.7-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M258.29,123.02s15.66-1.14,20.56,0,12.16,5.6,12.16,5.6c0,0-7-9.42-9.1-9.78s-10.06-1.85-10.06-1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M260.51,130.11s10.29,4.99,12.13,4.9,12.95-1.14,12.95-1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M266.61,123.37s-.44,3.76.52,5.25,3.12,5.01,6.65,5.51,7.78-1.09,8.91-3.54c.99-2.14.27-5.65.27-5.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M261.54,112.71s6.59.2,11.59-.16,21.68-2.71,21.68-2.71c0,0,.66-7.31-3.23-8.02,0,0-14.65,5.04-20.3,5.44l-5.65.4-4.1,5.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M317.17,119.49c-1.25.54-1.7,6.37-1.7,6.37,0,0,18.84-2.22,23.31-4.76s9.95-3.59,9.95-3.59l-4.84-2.89s-11.57,4.47-15.77,4.21-10.96.66-10.96.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M179.81,385.35s-3.98-6.26-7.4-13.94-8.54-20.2-8.54-20.2c0,0-24.72-3.8-33.42-3.2s-20.44,3.86-34.7.64c-21.72-4.89-28.02-7.85-33.42-9.35s-56.72-19.51-59.72-23.41.89-15.16,2.09-25.67-3.29-28.05,7.81-48.46c11.1-20.41,24.93-37.61,29.44-47.6s13.78-51.73,15.58-56.83,24.61-12.08,30.31-16.24,27.91-31.17,33.01-32.67,9.3-1.2,12,0,31.51,31.81,31.51,31.81c0,0-5.59,11.41-7.99,13.91l-4.2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M146.52,299.99s18.21,14.48,19.63,17.77,13.09,18.94,17.64,20.93,22.19,15.36,22.19,15.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M209.9,235.08s-28.35-1.5-36.03,0c-10.22,2-34.77,16.58-34.77,16.58,0,0-6.55-.62-26.05,0l-19.51.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M132.05,102.92s-.65,2.43.87,4.37,20.86,17.84,21.08,22.82-10.15,14.75-10.15,14.75l-6.98,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M125.1,114.66s-.43,4.42.65,6.45,11.3,16.8,13.69,20.28-8.45,12.28-8.45,12.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M117.28,128.62s-.87,3.22,0,5.6,13.04,19.66,13.69,21.67-13.86,11.63-17.12,11.41l-7.05-4.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.28,150.29s4.56,6.52,7.6,6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M109.89,157.03s2.39.87-1.96,3.04-5.65,9.56-21.29,5.21-18.03-11.62-18.03-11.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M103.47,163.77s-6.39,16.37-8.47,25.37-4.75,30.45-4.45,43.25,6.57,11.93-.02,35.72-37.27,37.68-37.27,37.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M344.72,208.51s-10.53,20.29-9.86,33.58c.62,12.06,8,19.12,19.26,19.26,0,0-6.38-4.52-6.38-9.53s3.82-8.03,3.82-8.03c0,0-.7,4.34,3.63,10.9s11.61,9.69,9.87,16.44-11.87,12.85-11.87,12.85c0,0,26.11,3.3,33.96-15.87,6-14.66.32-17.5,2.35-26.03s9.59-11.62,8.59-31.81c0,0,16.83,13.07,3.24,25.68,0,0,9.87-3.49,10-19.46s-14.03-28.12-23.78-35.84c0,0,8.66,6.77,17.6,2.44s11.78-11.78,11.78-11.78c0,0-9.21,9.07-17.6,5.82s-14.54-14.48-5.34-28.15,9.94-23.7,4.52-33.04-12.66-10.37-12.66-15.25,1.94-8.6-3.23-15.34-14.22-14.24-16.99-21.44c-6.92-17.98-26.04-29.85-44.99-24.74-13.91,3.75-19.43,5.96-19.43,5.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M360.29,99.79c1.27,20.21,22.34,12.09,22.34,12.09-14.24,15.68-33.14,8.61-43.09-.78s-6.4-32.99-8.25-35.27-10.1-1.71-17.49,1.85-12.58,13.94-12.58,13.94c0,0,7.22-3.82,15.65-3.2s15.05,4.35,15.05,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M355.26,138.98s.5,13.53-4.78,18.81-16.92,3.15-16.92,3.15c0,0,10.78,7.58,20.21,5.91,7.53-1.34,13.88-9.92,13.88-9.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M257.72,208.51s10.53,20.29,9.86,33.58c-.62,12.06-8,19.12-19.26,19.26,0,0,6.38-4.52,6.38-9.53s-3.82-8.03-3.82-8.03c0,0,.7,4.34-3.63,10.9s-11.61,9.69-9.87,16.44,11.87,12.85,11.87,12.85c0,0-26.11,3.3-33.96-15.87-6-14.66-.32-17.5-2.35-26.03s-9.59-11.62-8.59-31.81c0,0-16.83,13.07-3.24,25.68,0,0-9.87-3.49-10-19.46s14.03-28.12,23.78-35.84c0,0-8.66,6.77-17.6,2.44s-11.78-11.78-11.78-11.78c0,0,9.21,9.07,17.6,5.82s14.54-14.48,5.34-28.15c-9.21-13.67-9.94-23.7-4.52-33.04s12.66-10.37,12.66-15.25-1.94-8.6,3.23-15.34,14.22-14.24,16.99-21.44c6.92-17.98,26.04-29.85,44.99-24.74,13.91,3.75,19.43,5.96,19.43,5.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M242.15,99.79c-1.27,20.21-22.34,12.09-22.34,12.09,14.24,15.68,33.14,8.61,43.09-.78,9.95-9.39,6.4-32.99,8.25-35.27s10.1-1.71,17.49,1.85,12.58,13.94,12.58,13.94c0,0-7.22-3.82-15.65-3.2s-15.05,4.35-15.05,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M247.18,138.98s-.5,13.53,4.78,18.81,16.92,3.15,16.92,3.15c0,0-10.78,7.58-20.21,5.91-7.53-1.34-13.88-9.92-13.88-9.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.77,75.6s-.72,11.94,4.75,14.12c5.47,2.18,14.23,2.06,14.23,2.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.2,79.24s2.71,9.43,5.97,11.38,16.38.4,16.38.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 326.15,
    y1: 69.48,
    x2: 313.87,
    y2: 86.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 336.81,
    y1: 69.26,
    x2: 321.8,
    y2: 90.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 270.1,
    y1: 68.82,
    x2: 257.83,
    y2: 85.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 278.5,
    y1: 70.29,
    x2: 264.07,
    y2: 90.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M409.6,98.5s-.1-14.64-8.2-24.03-5.05-23.9,1.32-29.55c6.72-5.96,19.46-3.25,23.04,2.41s2.4,16.68,2.4,16.68c0,0,8.92-6.5,14.13-5.51,6.56,1.24,11,9.29,10.01,12.32-3.7,11.38-10.75,10.26-22.44,16.14-11.69,5.87-20.27,11.55-20.27,11.55h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChadflirt);
export default __webpack_public_path__ + "static/media/chadflirt.1fee859c5d7f73b4251a4ff1501a867e.svg";
export { ForwardRef as ReactComponent };